import script from "./SellerProductFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerProductFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./SellerProductFormModal.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__